import { render, staticRenderFns } from "./Login-v2.vue?vue&type=template&id=49adf55c"
import script from "./Login-v2.vue?vue&type=script&lang=js"
export * from "./Login-v2.vue?vue&type=script&lang=js"
import style0 from "./Login-v2.vue?vue&type=style&index=0&id=49adf55c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports